import { Trans } from "@lingui/react/macro";
import { useCallback, useState } from "react";

import { Switch } from "../components/ui-kit/fields/switch";

const STORAGE_PREFIX = "assignedOnly:";

export function AssignedOnlyToggle({
  value,
  onChange,
}: {
  value: boolean;
  onChange: (next: boolean) => void;
}) {
  return (
    <label className="flex cursor-pointer items-center gap-2 text-sm select-none">
      <Switch value={value} onChange={onChange} />
      <span>
        <Trans>Assigned to me only</Trans>
      </span>
    </label>
  );
}

export function useAssignedOnly(scope: string) {
  const key = STORAGE_PREFIX + scope;
  const [value, setValueState] = useState<boolean>(() => readStored(key));

  const setValue = useCallback(
    (next: boolean) => {
      setValueState(next);
      writeStored(key, next);
    },
    [key],
  );

  return [value, setValue] as const;
}

export function readAssignedOnly(scope: string): boolean {
  return readStored(STORAGE_PREFIX + scope);
}

export function writeAssignedOnly(scope: string, value: boolean) {
  writeStored(STORAGE_PREFIX + scope, value);
}

function readStored(key: string): boolean {
  try {
    return localStorage.getItem(key) === "true";
  } catch {
    return false;
  }
}

function writeStored(key: string, value: boolean) {
  try {
    localStorage.setItem(key, String(value));
  } catch (error) {
    console.warn("Cannot persist assigned-only setting", error);
  }
}
